module.exports = __webpack_public_path__ + "static/media/iclinicpay.3ce8b00e.svg";